import React from 'react';
import get from 'lodash/get';
import capitalize from 'lodash/capitalize';
import { useSelector } from 'react-redux';
import { selectToolError } from 'store/Agents/selectors';
import { FieldWrapper, Label, Field, FieldMessage } from './styled';
import { useIntl } from 'react-intl';

const fieldType = {
  boolean: 'checkbox',
  integer: 'number',
  string: 'text',
  list: 'text'
};

const NonBooleanField = ({
  defaultValue, parameters, param, onChangeField, disabled
}) => {
  const intl = useIntl();
  const base = get(parameters, `${param}.base`, 'string');
  const required = get(parameters, `${param}.mandatory`, false);
  const paramType = get(fieldType, `${base}`, 'text');
  const paramError = useSelector((state) => selectToolError(state, param));
  const extractName = (str) => capitalize(str.replace('_', ' '));
  const type = get(parameters, `${param}.type`, false);
  const message = type === 'list' ? intl.formatMessage({ id: 'agents.runAgent.listFieldMessage' }) : intl.formatMessage({ id: 'agents.runAgent.intFieldMessage' });

  return (
    <FieldWrapper key={ param } required={ required } disabled={ disabled }>
      <Label>{extractName(param)}</Label>
      <Field
        defaultValue={ defaultValue }
        onChange={ (e) => {
          const inputValue = e.target.value;
          const formattedValue = base === 'list'
            ? inputValue.split(',').map(item => item.trim())
            : inputValue;
          onChangeField(param, formattedValue, type);
        } }
        failed={ paramError }
        title={ paramError ? paramError.data[0] : param }
        type={ paramType }
        disabled={ disabled }
      />
      {(type === 'list' || type === 'integer') && <FieldMessage>{ message }</FieldMessage> }
    </FieldWrapper>
  );
};

export default NonBooleanField;
